import { type RootContainerProps } from "@client/content/types";
import { connectCustom } from "@client/lib/misc";
import { getSettingValueSelector, TargetSelector } from "@client/selectors";
import { type AppState } from "@client/types";
import Component, { type HTMLProps } from "./component";

const makeMapStateToProps = () => {
  const descriptionSelector = getSettingValueSelector(TargetSelector.Entity, "description");

  return (state: AppState, props: RootContainerProps): HTMLProps => {
    return {
      description: descriptionSelector(state, props),
      ...props
    };
  };
};

export default connectCustom(makeMapStateToProps)(Component);
